import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class AcquiringSeeds extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_seeds.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>  
          Acquiring Seeds
        </h2>
        <p>
          Marijuana grows from seeds. You may have mystery bag seeds lying around. These will work, but are not recommended. Acquiring seeds of a specific strain with good genetics is a much better option. Marijuana seeds are sometimes available in marijuana stores in legal states, but can also be bought online from international distributors for around $10 a seed. One recommended option is <a href="http://truenorthseedbank.com/" target="_blank">True North Seed Bank</a>, based in Canada. 
        </p>
        <h3>
          Terms to know when buying seeds
        </h3>
        <p>
          When purchasing seeds online you will be presented with a wide variety of strains to choose from. Keep an eye out for the following terms when browsing. 
        </p>
        <p>
          <span className="highlight">Feminized Seeds</span> are seeds that are guaranteed to produce female flowering plants. Female plants produce the bud that you want to harvest. We recommend buying these, otherwise you may end up with male plants which must be destroyed when they are old enough to be identified. Click here to learn how to identify the gender of your marijuana plants. 
        </p>
        <p>
          <span className="highlight">Autoflowering seeds</span> are seeds that produce plants that will automatically switch to flowering at a specified time without manual changes in their light rhythm. These produce smaller marijuana plants in a shorter time period and are great choices for first time growers.
        </p>
        <h3>Warning</h3>
        <p>
          Purchasing seeds online may not be legal in your area and in some occasions your order may be confiscated at the border. If this happens you may receive a scary letter from authorities regarding the laws you’re broke. This is usually the extent of the interaction, but use caution and know your local laws before ordering seeds online. Some distributors offer discrete shipping methods you may want to consider. 
        </p>
        <GuideButton slugTo="part-two-introduction" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/one_acquiring_seeds.js